import { useFm } from '@web3/base-hooks';
import styles from './index.module.less';
import { appPath } from '@web3/base-utils';

type ProductOverviewItem = {
  title: string;
  subtitle: string;
  icon: string;
};

export const ProductOverview = () => {
  const fm = useFm();

  const PRODUCT_OVERVIEW_DATA: ProductOverviewItem[] = [
    {
      title: fm('seamlessEarnings'),
      subtitle: fm('noHassleJustGrowth'),
      icon: `${appPath}/png/bybitsol/logo.png`,
    },
    {
      title: fm('bbsolDepositFee'),
      subtitle: fm('bbsolStakeSOL'),
      icon: `${appPath}/png/bybitsol/horn.png`,
    },
    {
      title: fm('cedeFiVersatility'),
      subtitle: fm('accessBbSol'),
      icon: `${appPath}/png/bybitsol/coin.png`,
    },
  ];

  return (
    <div className={styles.product}>
      <div className={styles.product__section}>
        <p className={styles.product__title}>{fm('maximiseYourSOL')}</p>
        <div className={styles.product__list}>
          <div className={styles.borderImage}></div>
          <img
            src={`${appPath}/png/bybitsol/ellipse2.png`}
            alt=""
            className={styles.mobileDecoration}
          />
          <img
            src={`${appPath}/png/bybitsol/ellipse3.png`}
            alt=""
            className={styles.desktopDecoration}
          />
          {PRODUCT_OVERVIEW_DATA.map((item, index) => (
            <div key={index} className={styles.product__item}>
              <div className={styles.product__item_icon}>
                <img
                  src={item.icon}
                  alt={item.title}
                  className={styles.product__item_image}
                />
              </div>
              <div className={styles.product__item_content}>
                <h3 className={styles.product__item_heading}>{item.title}</h3>
                <p className={styles.product__item_text}>{item.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
